const summaryKeyPairs = {
  InvoiceNo: 'Invoice #',
  PONo: 'PO #',
  ProjectNo: 'Project #',
  InvoiceAmount: 'Invoice Amount',
  AmountRemaining: 'Balance Due',
};

const summaryKeys = [
  'InvoiceNo',
  'PONo',
  'ProjectNo',
  'InvoiceAmount',
  'AmountRemaining',
];

const invoiceSummaryKeyPairs = {
  keys: summaryKeys,
  keyPairs: summaryKeyPairs,
};


const keyPairs = {
  InvoiceNumber: 'Invoice #',
  CompanyName: 'Company Name',
  POAFENumber: 'PO #',
  AmountRemaining: 'Amount Remaining',
};

const keys = [
  'InvoiceNumber',
  'CompanyName',
  'POAFENumber',
  'AmountRemaining',
];

const icons = [{
  icon: 'remove_red_eye',
  label: 'view',
}, {
  icon: 'attach_money',
  label: 'pay invoice',
}];

const invoiceDetailsKeyPairs = {
  keyPairs, keys,
};

export { invoiceDetailsKeyPairs, invoiceSummaryKeyPairs, icons };



// WEBPACK FOOTER //
// ./src/constants/invoicesKeyPairs.js